
import HeroSliderCard from './hero-slider-card-mobile'

export default
	data: -> page: 0

	props:
		block: Object

	components: { HeroSliderCard }

	computed:
		isDotPagination: -> @block.paginationStyle == 'dots'

		count: -> @block.heroSlides?.length || 0

	methods:
		change: ({index}) -> @page = index

		goto: (index) -> @$refs.carousel?.goto index

		next: ->
			page = Math.max(0, Math.min(@page + 1, @block?.heroSlides?.length - 1))
			@goto page

		back: ->
			page = Math.max(0, Math.min(@page - 1, @block?.heroSlides?.length - 1))
			@goto page

